// @ts-nocheck
import React, { useMemo } from 'react';
import intl from 'react-intl-universal';
import { Menu, MenuItem, MenuDivider, Intent, Button, ButtonGroup, Spinner } from '@blueprintjs/core';
import { Icon } from '@/components';
import { safeCallback } from '@/utils';
import { useGetPresignedUrlImage } from '@/hooks/query/attachments';

function LogoCell({ value }) {
  const { data, isLoading } = useGetPresignedUrlImage(value, { enabled: !!value });
  const url = data?.presigned_url ?? null;

  if (!value) return null;
  if (isLoading) return <Spinner size={16} />;
  if (!url) return null;

  return (
    <img
      src={url}
      alt="logo"
      style={{ width: 36, height: 36, objectFit: 'contain', borderRadius: '50%' }}
    />
  );
}

export function ActionMenuList({
  row: { original },
  payload: { onEdit, onDelete },
}) {
  return (
    <Menu>
      <MenuItem
        icon={<Icon icon="pen-18" />}
        text={intl.get('edit')}
        onClick={safeCallback(onEdit, original)}
      />
      <MenuDivider />
      <MenuItem
        icon={<Icon icon="trash-16" iconSize={16} />}
        text={intl.get('delete')}
        intent={Intent.DANGER}
        onClick={safeCallback(onDelete, original)}
      />
    </Menu>
  );
}

export const ActionsCell = ({ row: { original }, payload: { onEdit, onDelete } }) => (
  <ButtonGroup>
    <Button
      icon={<Icon icon="pen-18" iconSize={13} />}
      minimal
      onClick={safeCallback(onEdit, original)}
      style={{ marginRight: '5px' }}
    />
    <Button
      intent={Intent.DANGER}
      icon={<Icon icon="trash" iconSize={13} />}
      minimal
      onClick={safeCallback(onDelete, original)}
    />
  </ButtonGroup>
);

export function useLogoLibraryColumns() {
  return useMemo(
    () => [
      { Header: '', accessor: 'logo', Cell: ({ value }) => <LogoCell value={value} />, width: 40 },
      { Header: 'Logo #', accessor: 'logo_number', width: 120 },
      { Header: 'Vendor', accessor: 'supplier_name', width: 150 },
      { Header: 'Customer', accessor: 'customer_name', width: 150 },
      { Header: 'Program', accessor: 'program_name', width: 150 },
      { Header: 'Description', accessor: 'description', width: 100 },
      { Header: 'Position & Size', accessor: 'position', width: 100 },
      { Header: 'Imprint', accessor: 'imprint', width: 100 },
      {
        id: 'actions',
        Header: 'Actions',
        Cell: ActionsCell,
        width: 100,
        disableResizing: true,
      },
    ],
    [],
  );
}
